import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

function TestimSlider() {
  const swipers = document.querySelectorAll('.testimonials__slider[data-animated="true"]');

  if (!swipers.length) {
    return;
  }

  swipers.forEach((swiperEl) => {
    const direction = swiperEl.dataset.direction === 'reverse';

    const swiper = new Swiper(swiperEl, {
      modules: [Autoplay],
      slidesPerView: 'auto',
      spaceBetween: 28,
      loop: true,
      speed: 5000,

      // ✅ включаем свайп
      allowTouchMove: true,

      centeredSlides: false,

      autoplay: {
        delay: 0,
        disableOnInteraction: true, // 🔥 ключевая штука
        pauseOnMouseEnter: true,
        reverseDirection: direction,
      },

      breakpoints: {
        768: {
          spaceBetween: 32,
        },
        1024: {
          spaceBetween: 36,
        },
      },
    });

    // ✅ дополнительная гарантия стопа при тапе
    swiperEl.addEventListener('touchstart', () => {
      if (swiper.autoplay) {
        swiper.autoplay.stop();
      }
    });

    swiperEl.addEventListener('click', () => {
      if (swiper.autoplay) {
        swiper.autoplay.stop();
      }
    });
  });
}

export default TestimSlider;